import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import {LinkContainer} from "react-router-bootstrap";
import React from "react";
import OfferImg4 from "../../assets/freepik-frau-rumpfbeugehaltung-steht.jpeg";

import offerDescription from "../OfferDescription.jsx";
import {Kachel2} from "../Offer";

export default function Landsberg() {
    /* const [matches, setMatches] = useState(window.innerWidth);
     window.addEventListener("resize", checkSize);

     function checkSize() {
         setMatches(window.innerWidth);
     }*/
    return (
        <>
            <section className="offerSec">
                <h4 className="introHeader">{offerDescription[0].title}</h4>
                <div className="intro">{offerDescription[0].body}</div>
                <h2 id="offer">Angebot</h2>
                <br/>
                <br/>
                <Row lg={1} sm={12} className="g-4">
                    <Col>
                        <Card className="cardOffer">
                            <Card.Img className="cardImageDetailPopup" variant="top" src={OfferImg4}/>
                            <Card.Body>
                                <br/>
                                {Kachel2.description}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <LinkContainer to={`/`}>
                    <Button>Zurück</Button>
                </LinkContainer>
            </section>
        </>
    );
}
